// extracted by mini-css-extract-plugin
export default {"ticker":"style_ticker__FVOPC","marqueeText":"style_marqueeText__5Dr6N","item":"style_item__42heJ"};